// Real public.engagements columns, derived from database/migrations
// (002 create, 006 series, 010 org_id, 049 service, minus dropped driver_id,
// booker_id, hub_id; 2k adds needs_info / needs_info_fields). bl395aHotfixEngagementsDashboard.test.jsx re-derives this from migrations.
export const ENGAGEMENT_COLUMNS = [
    'id', 'confirmation_number', 'entity_id', 'account_id', 'schedule_id',
    'rider_id', 'extra_passenger_ids', 'service_type', 'origin', 'destination', 'zone_id',
    'pickup_address', 'dropoff_address', 'notes', 'quoted_amount', 'final_amount',
    'payment_status', 'status', 'created_by', 'updated_by', 'created_at',
    'updated_at', 'channel', 'series_id', 'series_occurrence_index',
    'series_occurrence_date', 'org_id', 'service_id', 'service_label',
    // BL-177 Step 2k: the "Needs info" tag on a trip made from a conversation.
    'needs_info', 'needs_info_fields', 'reservation_details',
];

export const ENGAGEMENT_PRICE_COLUMNS = ['quoted_amount', 'final_amount', 'payment_status'];

export const ENGAGEMENT_NO_PRICE_SELECT = ENGAGEMENT_COLUMNS
    .filter((column) => !ENGAGEMENT_PRICE_COLUMNS.includes(column))
    .join(', ');
